import { render, staticRenderFns } from "./AddEntity.vue?vue&type=template&id=cd8cda7e&"
import script from "./AddEntity.vue?vue&type=script&lang=js&"
export * from "./AddEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports